module.exports = __webpack_public_path__ + "static/media/rupee-circle.7e7fffcc.svg";